
























import { Vue, Component, Prop } from "vue-property-decorator";
import CardTitle from "../CardTitle.vue";
import { DocNominaResponsabileInfo } from "../../_models/docNominaResponsabileInfo";
import { bus } from "../../main";
import * as user from "../../_store/user.module";
import * as data from "../../_store/data.module";
import * as images from "../../assets/images";
//@ts-ignore
import * as pdfMake from "pdfmake/build/pdfmake";
//@ts-ignore
import * as pdfFonts from "pdfmake/build/vfs_fonts";
import { router } from "../../_router";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  components: {
    CardTitle
  }
})
export default class NominaResponsabileReview extends Vue {
  @Prop() idDoc!: number;
  @Prop() idStatoDoc!: number;
  @Prop() ruoloUtente!: number;
  // @Prop() docElements!: DocNominaResponsabileInfo;
  private elements: DocNominaResponsabileInfo;
  // private tempInfo: DocNominaResponsabileInfo;
  private titleParams: object;

  constructor() {
    super();
    this.titleParams = {
      title: "Revisione Nomina Responsabile Dati",
      cols: "10",
      sm: "5",
      md: "5",
      lg: "4"
    };
    // this.elements = {
    //   nomeAzienda: this.docElements.nomeAzienda,
    //   nomeIstituto: this.docElements.nomeIstituto,
    //   idAzienda: this.docElements.idAzienda,
    //   idIstituto: this.docElements.idIstituto,
    //   dataDocumento: this.docElements.dataDocumento,
    //   firmaUno: this.docElements.firmaUno,
    //   firmaDue: this.docElements.firmaDue
    // };
    this.elements = {
      nomeAzienda: "",
      nomeIstituto: "",
      idAzienda: 0,
      idIstituto: 0,
      dataDocumento: "",
      firmaUno: "",
      firmaDue: "",
      idDoc: 0
    };
  }

  createDoc() {
    var dd = {
      pageSize: "A4",
      // ****** FOOTER *********//
      // footer: function(/*currentPage, pageCount*/) {
      //   return [
      //     {
      //       image: images.footerDocVallauri,
      //       width: "560",
      //       height: "80",
      //       margin: [20, 0]
      //     }
      //   ];
      // },
      // ******** HEADER ******** //
      // header: function(/*currentPage, pageCount, pageSize*/) {
      //   return [
      //     {
      //       // image: images.authHeader,
      //       image: images.headerDocVallauri,
      //       width: "525",
      //       margin: [35,30,1,35]
      //     }
      //   ];
      // },
      //******** TESTO DEL DOCUMENTO  ********/
      content: [
        {
          image: images.headerDocVallauri,
          width: "500",
        },
        {
          text: "CONTRATTO PER LA NOMINA DEL RESPONSABILE DEL TRATTAMENTO",
          alignment: "center",
          margin: [0, 10, 0, 0],
          bold: true
        },
        {
          text: "(ex art. 28 GDPR 2016/679)",
          // margin: [170,0,0,0],
          alignment: "center",
          italics: true
        },
        {
          text: "CONSIDERATO CHE",
          alignment: "center",
          margin: [0,10,0,0]
        },
        {
          text: "Le clausole contrattuali di cui alla Decisione di Esecuzione (UE) 2021/915 della Commissione del 4 giugno 2021 relativa alle clausole contrattuali tipo tra titolari del trattamento e responsabili del trattamento a norma dell'articolo 28, paragrafo 7, del regolamento (UE) 2016/679 del Parlamento europeo e del Consiglio soddisfano i requisiti per i contratti tra titolari del trattamento e responsabili del trattamento di cui all'articolo 28, paragrafi 3 e 4, del regolamento (UE) 2016/679.",
          style: "bodyText",
          margin: [0,10,0,0]
        },
        {
          text: "Le clausole contrattuali tipo possono essere utilizzate nei contratti tra un titolare del trattamento e un responsabile del trattamento che tratta dati personali per conto del titolare del trattamento e che le parti intendono utilizzarle.",
          style: "bodyText",
          margin: [0,5,0,0]
        },
        {
          text: "ADOZIONE DI CLAUSOLE CONTRATTUALI TIPO",
          alignment: "center",
          style: "bodyText",
          margin: [0,10,0,0],
          bold: true
        },
        {
          text: "(Decisione di Esecuzione (UE) 2021/915 della Commissione del 4 giugno 2021)",
          alignment: "center",
          style: "bodyText",
          bold: true
        },
        {
          text: "SEZIONE I",
          alignment: "center",
          margin: [0,10,0,0],
          style: "bodyText"
        },
        {
          text: "Clausola 1",
          alignment: "center",
          margin: [0,10,0,0],
          style: "bodyText"
        },
        {
          text: "Scopo e ambito di applicazione",
          alignment: "center",
          margin: [0,10,0,0],
          style: "bodyText",
          bold: true
        },
        {
          text: "a)	Scopo delle presenti clausole contrattuali tipo (di seguito «clausole») è garantire il rispetto dell'articolo 28, paragrafi 3 e 4, del regolamento (UE) 2016/679 del Parlamento europeo e del Consiglio, del 27 aprile 2016, relativo alla protezione delle persone fisiche con riguardo al trattamento dei dati personali, nonché alla libera circolazione di tali dati e che abroga la direttiva 95/46/CE (regolamento generale sulla protezione dei dati).",
          margin: [0,10,0,0],
          style: "bodyText"
        },
        {
          text: "b)	I titolari del trattamento e i responsabili del trattamento di cui all'allegato I hanno accettato le presenti clausole al fine di garantire il rispetto dell'articolo 28, paragrafi 3 e 4, del regolamento (UE) 2016/679 e/o dell'articolo 29, paragrafi 3 e 4, del regolamento (UE) 2018/1725.",
          margin: [0,5,0,0],
          style: "bodyText"
        },
        {
          text: "c)	Le presenti clausole si applicano al trattamento dei dati personali specificato all'allegato II.",
          margin: [0,5,0,0],
          style: "bodyText"
        },
        {
          text: "d)	Gli allegati da I a IV costituiscono parte integrante delle clausole.",
          margin: [0,5,0,0],
          style: "bodyText"
        },
        {
          text: "e)	Le presenti clausole lasciano impregiudicati gli obblighi cui è soggetto il titolare del trattamento a norma del regolamento (UE) 2016/679 e/o del regolamento (UE) 2018/1725.",
          margin: [0,5,0,0],
          style: "bodyText"
        },
        {
          text: "f)	Le presenti clausole non garantiscono, di per sé, il rispetto degli obblighi connessi ai trasferimenti internazionali conformemente al capo V del regolamento (UE) 2016/679 o del regolamento (UE) 2018/1725.",
          margin: [0,5,0,0],
          style: "bodyText"
        },
        {
          text: "Clausola 2",
          alignment: "center",
          margin: [0,20,0,0],
          style: "bodyText"
        },
        {
          text: "Invariabilità delle clausole",
          alignment: "center",
          style: "bodyText",
          margin: [0,5,0,0],
          italics: true,
          bold: true
        },
        {
          text: "a)	Le parti si impegnano a non modificare le clausole se non per aggiungere o aggiornare informazioni negli allegati.",
          margin: [0,5,0,0],
          style: "bodyText"
        },
        {
          text: "b)	Ciò non impedisce alle parti di includere le clausole contrattuali tipo stabilite nelle presenti clausole in un contratto più ampio o di aggiungere altre clausole o garanzie supplementari, purché queste non contraddicano, direttamente o indirettamente, le presenti clausole o ledano i diritti o le libertà fondamentali degli interessati.",
          margin: [0,5,0,0],
          style: "bodyText",
          // pageBreak: "after"
        },
        {
          image: images.footerDocVallauri,
          width: "500",
          margin: [0,45,0,0]
        },
        {
          image: images.headerDocVallauri,
          width: "500",
        },
        {
          text: "Clausola 3",
          alignment: "center",
          margin: [0,10,0,0],
          style: "bodyText"
        },
        {
          text: "Interpretazione",
          alignment: "center",
          style: "bodyText",
          margin: [0,5,0,0],
          italics: true,
          bold: true
        },
        {
          text: "a)	Quando le presenti clausole utilizzano i termini definiti, rispettivamente, nel regolamento (UE) 2016/679 o nel regolamento (UE) 2018/1725, tali termini hanno lo stesso significato di cui al regolamento interessato.",
          margin: [0,5,0,0],
          style: "bodyText"
        },
        {
          text: "b)	Le presenti clausole vanno lette e interpretate alla luce delle disposizioni del regolamento (UE) 2016/679 o del regolamento (UE) 2018/1725, rispettivamente.",
          margin: [0,5,0,0],
          style: "bodyText"
        },
        {
          text: "c)	Le presenti clausole non devono essere interpretate in un senso che non sia conforme ai diritti e agli obblighi previsti dal regolamento (UE) 2016/679 / dal regolamento (UE) 2018/1725, o che pregiudichi i diritti o le libertà fondamentali degli interessati.",
          margin: [0,5,0,0],
          style: "bodyText"
        },
        {
          text: "Clausola 4",
          alignment: "center",
          margin: [0,15,0,0],
          style: "bodyText"
        },
        {
          text: "Gerarchia",
          alignment: "center",
          style: "bodyText",
          margin: [0,5,0,0],
          italics: true,
          bold: true
        },
        {
          text: "a)	In caso di contraddizione tra le presenti clausole e le disposizioni di accordi correlati, vigenti tra le parti al momento dell'accettazione delle presenti clausole, o conclusi successivamente, prevalgono le presenti clausole.",
          margin: [0,5,0,0],
          style: "bodyText"
        },
        {
          text: "Clausola 5 (facoltativa)",
          alignment: "center",
          margin: [0,15,0,0],
          style: "bodyText"
        },
        {
          text: "Clausola di adesione successiva",
          alignment: "center",
          style: "bodyText",
          margin: [0,5,0,0],
          italics: true,
          bold: true
        },
        {
          text: "a)	Qualunque entità che non sia parte delle presenti clausole può, con l'accordo di tutte le parti, aderire alle presenti clausole in qualunque momento, in qualità di titolare del trattamento o di responsabile del trattamento, compilando gli allegati e firmando l'allegato I.",
          margin: [0,5,0,0],
          style: "bodyText" 
        },
        {
          text: "b)	Una volta compilati e firmati gli allegati di cui alla lettera a), l'entità aderente è considerata parte delle presenti clausole e ha i diritti e gli obblighi di un titolare del trattamento o di un responsabile del trattamento, conformemente alla sua designazione nell'allegato I.",
          margin: [0,5,0,0],
          style: "bodyText" 
        },
        {
          text: "c)	L'entità aderente non ha diritti od obblighi derivanti a norma delle presenti clausole per il periodo precedente all'adesione.",
          margin: [0,5,0,0],
          style: "bodyText" 
        },
        {
          text: "SEZIONE II",
          alignment: "center",
          margin: [0,15,0,0],
          style: "bodyText"
        },
        {
          text: "OBBLIGHI DELLE PARTI",
          alignment: "center",
          margin: [0,5,0,0],
          bold: true
        },
        {
          text: "Clausola 6",
          alignment: "center",
          margin: [0,10,0,0],
          style: "bodyText"
        },
        {
          text: "Descrizione del trattamento",
          alignment: "center",
          style: "bodyText",
          margin: [0,5,0,0],
          italics: true,
          bold: true
        },
        {
          text: "a)	I dettagli dei trattamenti, in particolare le categorie di dati personali e le finalità del trattamento per le quali i dati personali sono trattati per conto del titolare del trattamento, sono specificati nell'allegato II.",
          margin: [0,5,0,0],
          style: "bodyText",
          // pageBreak: "after"
        },
        {
          text: "Clausola 7",
          alignment: "center",
          margin: [0,10,0,0],
          style: "bodyText"
        },
        {
          text: "Obblighi delle parti",
          alignment: "center",
          style: "bodyText",
          margin: [0,5,0,0],
          italics: true,
          bold: true
        },
        {
          text: "7.1 Istruzioni",
          style: "bodyText",
          margin: [0,5,0,0],
          italics: true,
          bold: true
        },
        {
          text: "a)	Il responsabile del trattamento tratta i dati personali soltanto su istruzione documentata del titolare del trattamento, salvo che lo richieda il diritto dell'Unione o nazionale cui è soggetto il responsabile del trattamento. In tal caso, il responsabile del trattamento informa il titolare del trattamento circa tale obbligo giuridico prima del trattamento, a meno che il diritto lo vieti per rilevanti motivi di interesse pubblico. Il titolare del trattamento può anche impartire istruzioni successive per tutta la durata del trattamento dei dati personali. Tali istruzioni sono sempre documentate.",
          margin: [0,5,0,0],
          style: "bodyText" 
        },
        {
          image: images.footerDocVallauri,
          width: "500",
          margin: [0,0,0,0]
        },
        {
          image: images.headerDocVallauri,
          width: "500",
        },
        {
          text: "b)	Il responsabile del trattamento informa immediatamente il titolare del trattamento qualora, a suo parere, le istruzioni del titolare del trattamento violino il regolamento (UE) 2016/679 o le disposizioni applicabili, nazionali o dell'Unione, relative alla protezione dei dati.",
          margin: [0,5,0,0],
          style: "bodyText" 
        },
        {
          text: "7.2 Limitazione delle finalità",
          style: "bodyText",
          margin: [0,10,0,0],
          italics: true,
          bold: true
        },
        {
          text: "a)	Il responsabile del trattamento tratta i dati personali soltanto per le finalità specifiche del trattamento di cui all'allegato II, salvo ulteriori istruzioni del titolare del trattamento.",
          margin: [0,5,0,0],
          style: "bodyText" 
        },
        {
          text: "7.3 Durata del trattamento dei dati personali",
          style: "bodyText",
          margin: [0,10,0,0],
          italics: true,
          bold: true
        },
        {
          text: "a)	Il responsabile del trattamento tratta i dati personali soltanto per la durata specificata nell'allegato II.",
          margin: [0,5,0,0],
          style: "bodyText" 
        },
        {
          text: "7.4 Sicurezza del trattamento",
          style: "bodyText",
          margin: [0,10,0,0],
          italics: true,
          bold: true
        },
        {
          text: "a)	Il responsabile del trattamento mette in atto almeno le misure tecniche e organizzative specificate nell'allegato III per garantire la sicurezza dei dati personali. Ciò include la protezione da ogni violazione di sicurezza che comporti accidentalmente o in modo illecito la distruzione, la perdita, la modifica, la divulgazione non autorizzata o l'accesso ai dati (violazione dei dati personali). Nel valutare l'adeguato livello di sicurezza, le parti tengono debitamente conto dello stato dell'arte, dei costi di attuazione, nonché della natura, dell'ambito di applicazione, del contesto e delle finalità del trattamento, come anche dei rischi per gli interessati.",
          margin: [0,5,0,0],
          style: "bodyText"
        },
        {
          text: "b)	Il responsabile del trattamento concede l'accesso ai dati personali oggetto di trattamento ai membri del suo personale soltanto nella misura strettamente necessaria per l'attuazione, la gestione e il controllo del contratto. Il responsabile del trattamento garantisce che le persone autorizzate al trattamento dei dati personali ricevuti si siano impegnate alla riservatezza o abbiano un adeguato obbligo legale di riservatezza.",
          margin: [0,5,0,0],
          style: "bodyText"
        },
        {
          text: "7.5 Dati sensibili",
          style: "bodyText",
          margin: [0,10,0,0],
          italics: true,
          bold: true
        },
        {
          text: "a)	Se il trattamento riguarda dati personali che rivelino l'origine razziale o etnica, le opinioni politiche, le convinzioni religiose o filosofiche o l'appartenenza sindacale, dati genetici o dati biometrici intesi a identificare in modo univoco una persona fisica, dati relativi alla salute o alla vita sessuale o all'orientamento sessuale della persona, o dati relativi a condanne penali e a reati («dati sensibili»), il responsabile del trattamento applica limitazioni specifiche e/o garanzie supplementari.",
          margin: [0,5,0,0],
          style: "bodyText",
          // pageBreak: "after"
        },
        {
          text: "7.6 Documentazione e rispetto",
          style: "bodyText",
          margin: [0,10,0,0],
          italics: true,
          bold: true
        },
        {
          text: "a)	Le parti devono essere in grado di dimostrare il rispetto delle presenti clausole.",
          margin: [0,5,0,0],
          style: "bodyText"
        },
        {
          text: "b)	Il responsabile del trattamento risponde prontamente e adeguatamente alle richieste di informazioni del titolare del trattamento relative al trattamento dei dati conformemente alle presenti clausole.",
          margin: [0,5,0,0],
          style: "bodyText"
        },
        {
          text: "c)	Il responsabile del trattamento mette a disposizione del titolare del trattamento tutte le informazioni necessarie a dimostrare il rispetto degli obblighi stabiliti nelle presenti clausole e che derivano direttamente dal regolamento (UE) 2016/679. Su richiesta del titolare del trattamento, il responsabile del trattamento consente e contribuisce alle attività di revisione delle attività di trattamento di cui alle presenti clausole, a intervalli ragionevoli o se vi sono indicazioni di inosservanza. Nel decidere in merito a un riesame o a un'attività di revisione, il titolare del trattamento può tenere conto delle pertinenti certificazioni in possesso del responsabile del trattamento.",
          margin: [0,5,0,0],
          style: "bodyText"
        },
        {
          text: "d)	Il titolare del trattamento può scegliere di condurre l'attività di revisione autonomamente o incaricare un revisore indipendente. Le attività di revisione possono comprendere anche ispezioni nei locali o nelle strutture fisiche del responsabile del trattamento e, se del caso, sono effettuate con un preavviso ragionevole.",
          margin: [0,5,0,0],
          style: "bodyText"
        },
        {
          text: "e)	Su richiesta, le parti mettono a disposizione della o delle autorità di controllo competenti le informazioni di cui alla presente clausola, compresi i risultati di eventuali attività di revisione.",
          margin: [0,5,0,0],
          style: "bodyText"
        },
        {
          image: images.footerDocVallauri,
          width: "500",
          margin: [0,30,0,0]
        },
        {
          image: images.headerDocVallauri,
          width: "500",
        },
        {
          text: "7.7	Ricorso a sub-responsabili del trattamento",
          style: "bodyText",
          margin: [0,4,0,0],
          italics: true,
          bold: true
        },
        {
          text: "a)	AUTORIZZAZIONE PRELIMINARE SPECIFICA: Il responsabile del trattamento non può subcontrattare a un sub-responsabile del trattamento i trattamenti da effettuare per conto del titolare del trattamento conformemente alle presenti clausole senza la previa autorizzazione specifica scritta del titolare del trattamento. Il responsabile del trattamento presenta la richiesta di autorizzazione specifica almeno 30 giorni prima di ricorrere al sub-responsabile del trattamento in questione, unitamente alle informazioni necessarie per consentire al titolare del trattamento di decidere in merito all'autorizzazione. L'elenco dei sub-responsabili del trattamento autorizzati dal titolare del trattamento figura nell'allegato IV. Le parti tengono aggiornato tale allegato.",
          margin: [0,4,0,0],
          style: "bodyText"
        },
        {
          text: "b)	Qualora il responsabile del trattamento ricorra a un sub-responsabile del trattamento per l'esecuzione di specifiche attività di trattamento (per conto del responsabile del trattamento), stipula un contratto che impone al sub-responsabile del trattamento, nella sostanza, gli stessi obblighi in materia di protezione dei dati imposti al responsabile del trattamento conformemente alle presenti clausole. Il responsabile del trattamento si assicura che il sub-responsabile del trattamento rispetti gli obblighi cui il responsabile del trattamento è soggetto a norma delle presenti clausole e del regolamento (UE) 2016/679.",
          margin: [0,4,0,0],
          style: "bodyText"
        },
        {
          text: "c)	Su richiesta del titolare del trattamento, il responsabile del trattamento gli fornisce copia del contratto stipulato con il sub-responsabile del trattamento e di ogni successiva modifica. Nella misura necessaria a proteggere segreti aziendali o altre informazioni riservate, compresi i dati personali, il responsabile del trattamento può espungere informazioni dal contratto prima di trasmetterne una copia.",
          margin: [0,4,0,0],
          style: "bodyText"
        },
        {
          text: "d)	Il responsabile del trattamento rimane pienamente responsabile nei confronti del titolare del trattamento dell'adempimento degli obblighi del sub-responsabile del trattamento derivanti dal contratto che questi ha stipulato con il responsabile del trattamento. Il responsabile del trattamento notifica al titolare del trattamento qualunque inadempimento, da parte del sub-responsabile del trattamento, degli obblighi contrattuali",
          margin: [0,4,0,0],
          style: "bodyText"
        },
        {
          text: "e)	Il responsabile del trattamento concorda con il sub-responsabile del trattamento una clausola del terzo beneficiario secondo la quale, qualora il responsabile del trattamento sia scomparso di fatto, abbia giuridicamente cessato di esistere o sia divenuto insolvente, il titolare del trattamento ha diritto di risolvere il contratto con il sub-responsabile del trattamento e di imporre a quest'ultimo di cancellare o restituire i dati personali.",
          margin: [0,4,0,0],
          style: "bodyText",
          // pageBreak: "after"
        },
        {
          text: "7.8 Trasferimenti internazionali",
          style: "bodyText",
          margin: [0,4,0,0],
          italics: true,
          bold: true
        },
        {
          text: "a)	Qualunque trasferimento di dati verso un paese terzo o un'organizzazione internazionale da parte del responsabile del trattamento è effettuato soltanto su istruzione documentata del titolare del trattamento o per adempiere a un requisito specifico a norma del diritto dell'Unione o degli Stati membri cui è soggetto il responsabile del trattamento, e nel rispetto del capo V del regolamento (UE) 2016/679.",
          margin: [0,4,0,0],
          style: "bodyText"
        },
        {
          text: "b)	Il titolare del trattamento conviene che, qualora il responsabile del trattamento ricorra a un sub-responsabile del trattamento conformemente alla clausola 7.7 per l'esecuzione di specifiche attività di trattamento (per conto del titolare del trattamento) e tali attività di trattamento comportino il trasferimento di dati personali ai sensi del capo V del regolamento (UE) 2016/679, il responsabile del trattamento e il sub-responsabile del trattamento possono garantire il rispetto del capo V del regolamento (UE) 2016/679 utilizzando le clausole contrattuali tipo adottate dalla Commissione conformemente all'articolo 46, paragrafo 2, del regolamento (UE) 2016/679, purché le condizioni per l'uso di tali clausole contrattuali tipo siano soddisfatte.",
          margin: [0,4,0,0],
          style: "bodyText"
        },
        {
          text: "Clausola 8",
          alignment: "center",
          margin: [0,5,0,0],
          style: "bodyText"
        },
        {
          text: "Assistenza al titolare del trattamento",
          alignment: "center",
          style: "bodyText",
          margin: [0,4,0,0],
          italics: true,
          bold: true
        },
        {
          text: "a)	Il responsabile del trattamento notifica prontamente al titolare del trattamento qualunque richiesta ricevuta dall'interessato. Non risponde egli stesso alla richiesta, a meno che sia stato autorizzato in tal senso dal titolare del trattamento.",
          margin: [0,4,0,0],
          style: "bodyText"
        },
        {
          text: "b)	Il responsabile del trattamento assiste il titolare del trattamento nell'adempimento degli obblighi di rispondere alle richieste degli interessati per l'esercizio dei loro diritti, tenuto conto della natura del trattamento. Nell'adempiere agli obblighi di cui alle lettere a) e b), il responsabile del trattamento si attiene alle istruzioni del titolare del trattamento.",
          margin: [0,4,0,0],
          style: "bodyText"  
        },
        {
          image: images.footerDocVallauri,
          width: "500",
          margin: [0,0,0,0]
        },
        {
          image: images.headerDocVallauri,
          width: "500",
        },
        {
          text: "c)	Oltre all'obbligo di assistere il titolare del trattamento in conformità della clausola 8, lettera b), il responsabile del trattamento assiste il titolare del trattamento anche nel garantire il rispetto dei seguenti obblighi, tenuto conto della natura del trattamento dei dati e delle informazioni a disposizione del responsabile del trattamento:",
          margin: [0,5,0,0],
          style: "bodyText" 
        },
        {
          ol: [
            {
              text: "l'obbligo di effettuare una valutazione dell'impatto dei trattamenti previsti sulla protezione dei dati personali («valutazione d'impatto sulla protezione dei dati») qualora un tipo di trattamento possa presentare un rischio elevato per i diritti e le libertà delle persone fisiche;",
              margin: [0,5,0,0],
              style: "bodyText"
            },
            {
              text: "l'obbligo, prima di procedere al trattamento, di consultare la o le autorità di controllo competenti qualora la valutazione d'impatto sulla protezione dei dati indichi che il trattamento presenterebbe un rischio elevato in assenza di misure adottate dal titolare del trattamento per attenuare il rischio;",
              margin: [0,5,0,0],
              style: "bodyText"
            },
            {
              text: "l'obbligo di garantire che i dati personali siano esatti e aggiornati, informando senza indugio il titolare del trattamento qualora il responsabile del trattamento venga a conoscenza del fatto che i dati personali che sta trattando sono inesatti o obsoleti;",
              margin: [0,5,0,0],
              style: "bodyText"
            },
            {
              text: "gli obblighi di cui all'articolo 32 regolamento (UE) 2016/679.",
              margin: [0,5,0,0],
              style: "bodyText"
            }
          ],
          margin: [10,0,0,0]
        },
        {
          text: "d)	Le parti stabiliscono nell'allegato III le misure tecniche e organizzative adeguate con cui il responsabile del trattamento è tenuto ad assistere il titolare del trattamento nell'applicazione della presente clausola, nonché l'ambito di applicazione e la portata dell'assistenza richiesta.",
          margin: [0,5,0,0],
          style: "bodyText"
        },
        {
          text: "Clausola 9",
          alignment: "center",
          margin: [0,10,0,0],
          style: "bodyText"
        },
        {
          text: "Notifica di una violazione dei dati personali",
          alignment: "center",
          style: "bodyText",
          margin: [0,5,0,0],
          italics: true,
          bold: true
        },
        {
          text: "In caso di violazione dei dati personali, il responsabile del trattamento coopera con il titolare del trattamento e lo assiste nell'adempimento degli obblighi che incombono a quest'ultimo a norma degli articoli 33 e 34 del regolamento (UE) 2016/679, ove applicabile, tenuto conto della natura del trattamento e delle informazioni a disposizione del responsabile del trattamento.",
          margin: [0,5,0,0],
          style: "bodyText"
        },
        {
          text: "9.1 Violazione riguardante dati trattati dal titolare del trattamento",
          style: "bodyText",
          margin: [0,4,0,0],
          italics: true,
          bold: true
        },
        {
          text: "In caso di una violazione dei dati personali trattati dal titolare del trattamento, il responsabile del trattamento assiste il titolare del trattamento:",
          margin: [0,5,0,0],
          style: "bodyText"
        },
        {
          text: "a)	nel notificare la violazione dei dati personali alla o alle autorità di controllo competenti, senza ingiustificato ritardo dopo che il titolare del trattamento ne è venuto a conoscenza, se del caso (a meno che sia improbabile che la violazione dei dati personali presenti un rischio per i diritti e le libertà delle persone fisiche);",
          margin: [0,5,0,0],
          style: "bodyText"
        },
        {
          text: "b)	nell'ottenere le seguenti informazioni che, in conformità dell'articolo 33, paragrafo 3, del regolamento (UE) 2016/679, devono essere indicate nella notifica del titolare del trattamento e includere almeno:",
          margin: [0,5,0,0],
          style: "bodyText"
        },
        {
          ol: [
            {
              text: "la natura dei dati personali compresi, ove possibile, le categorie e il numero approssimativo di interessati in questione nonché le categorie e il numero approssimativo di registrazioni dei dati personali in questione;",
              margin: [0,5,0,0],
              style: "bodyText"
            },
            {
              text: "le probabili conseguenze della violazione dei dati personali;",
              margin: [0,5,0,0],
              style: "bodyText"
            },
            {
              text: "le misure adottate o di cui si propone l'adozione da parte del titolare del trattamento per porre rimedio alla violazione dei dati personali, se del caso anche per attenuarne i possibili effetti negativi.",
              margin: [0,5,0,0],
              style: "bodyText"
            }
          ],
          margin: [10,0,0,0]
        },
        {
          text: "Qualora, e nella misura in cui, non sia possibile fornire tutte le informazioni contemporaneamente, la notifica iniziale contiene le informazioni disponibili in quel momento, e le altre informazioni sono fornite successivamente, non appena disponibili, senza ingiustificato ritardo.",
          margin: [0,5,0,0],
          style: "bodyText"
        },
        {
          text: "c)	nell'adempiere, in conformità dell'articolo 34 del regolamento (UE) 2016/679, all'obbligo di comunicare senza ingiustificato ritardo la violazione dei dati personali all'interessato, qualora la violazione dei dati personali sia suscettibile di presentare un rischio elevato per i diritti e le libertà delle persone fisiche.",
          margin: [0,5,0,0],
          style: "bodyText"
        },
        {
          image: images.footerDocVallauri,
          width: "500",
          margin: [0,30,0,0]
        },
        {
          image: images.headerDocVallauri,
          width: "500",
        },
        {
          text: "9.2 Violazione riguardante dati trattati dal responsabile del trattamento",
          style: "bodyText",
          margin: [0,4,0,0],
          italics: true,
          bold: true
        },
        {
          text: "In caso di una violazione dei dati personali trattati dal responsabile del trattamento, quest'ultimo ne dà notifica al titolare del trattamento senza ingiustificato ritardo dopo esserne venuto a conoscenza. La notifica contiene almeno:",
          margin: [0,4,0,0],
          style: "bodyText"
        },
        {
          text: "a)	una descrizione della natura della violazione (compresi, ove possibile, le categorie e il numero approssimativo di interessati e di registrazioni dei dati in questione);",
          margin: [0,4,0,0],
          style: "bodyText"
        },
        {
          text: "b)	i recapiti di un punto di contatto presso il quale possono essere ottenute maggiori informazioni sulla violazione dei dati personali;",
          margin: [0,4,0,0],
          style: "bodyText"
        },
        {
          text: "c)	le probabili conseguenze della violazione dei dati personali e le misure adottate o di cui si propone l'adozione per porre rimedio alla violazione, anche per attenuarne i possibili effetti negativi.",
          margin: [0,4,0,0],
          style: "bodyText"
        },
        {
          text: "Qualora, e nella misura in cui, non sia possibile fornire tutte le informazioni contemporaneamente, la notifica iniziale contiene le informazioni disponibili in quel momento, e le altre informazioni sono fornite successivamente, non appena disponibili, senza ingiustificato ritardo.",
          margin: [0,4,0,0],
          style: "bodyText"
        },
        {
          text: "Le parti stabiliscono nell'allegato III tutti gli altri elementi che il responsabile del trattamento è tenuto a fornire quando assiste il titolare del trattamento nell'adempimento degli obblighi che incombono al titolare del trattamento a norma degli articoli 33 e 34 del regolamento (UE) 2016/679.",
          margin: [0,4,0,0],
          style: "bodyText"
        },
        {
          text: "SEZIONE III",
          alignment: "center",
          margin: [0,15,0,0],
          style: "bodyText"
        },
        {
          text: "DISPOSIZIONI FINALI",
          alignment: "center",
          margin: [0,5,0,0],
          bold: true
        },
        {
          text: "Clausola 10",
          alignment: "center",
          margin: [0,10,0,0],
          style: "bodyText"
        },
        {
          text: "Inosservanza delle clausole e risoluzione",
          alignment: "center",
          style: "bodyText",
          margin: [0,4,0,0],
          italics: true,
          bold: true
        },
        {
          text: "a)	Fatte salve le disposizioni del regolamento (UE) 2016/679, qualora il responsabile del trattamento violi gli obblighi che gli incombono a norma delle presenti clausole, il titolare del trattamento può dare istruzione al responsabile del trattamento di sospendere il trattamento dei dati personali fino a quando quest'ultimo non rispetti le presenti clausole o non sia risolto il contratto. Il responsabile del trattamento informa prontamente il titolare del trattamento qualora, per qualunque motivo, non sia in grado di rispettare le presenti clausole.",
          margin: [0,4,0,0],
          style: "bodyText"
        },
        {
          text: "b)	Il titolare del trattamento ha diritto di risolvere il contratto per quanto riguarda il trattamento dei dati personali conformemente alle presenti clausole qualora:",
          margin: [0,4,0,0],
          style: "bodyText"
        },
        {
          ol: [
            {
              text: "il trattamento dei dati personali da parte del responsabile del trattamento sia stato sospeso dal titolare del trattamento in conformità della lettera a) e il rispetto delle presenti clausole non sia ripristinato entro un termine ragionevole e in ogni caso entro un mese dalla sospensione;",
              margin: [0,4,0,0],
              style: "bodyText"
            },
            {
              text: "2)	il responsabile del trattamento violi in modo sostanziale o persistente le presenti clausole o gli obblighi che gli incombono a norma del regolamento (UE) 2016/679;",
              margin: [0,4,0,0],
              style: "bodyText"
            },
            {
              text: "3)	il responsabile del trattamento non rispetti una decisione vincolante di un organo giurisdizionale competente o della o delle autorità di controllo competenti per quanto riguarda i suoi obblighi in conformità delle presenti clausole o del regolamento (UE) 2016/679.",
              margin: [0,4,0,0],
              style: "bodyText"
            }
          ],
          margin: [10,0,0,0]
        },
        {
          text: "c)	Il responsabile del trattamento ha diritto di risolvere il contratto per quanto riguarda il trattamento dei dati personali a norma delle presenti clausole qualora, dopo aver informato il titolare del trattamento che le sue istruzioni violano i requisiti giuridici applicabili in conformità della clausola 7.1, lettera b), il titolare del trattamento insista sul rispetto delle istruzioni.",
          margin: [0,4,0,0],
          style: "bodyText"
        },
        {
          text: "d)	Dopo la risoluzione del contratto il responsabile del trattamento, a scelta del titolare del trattamento, cancella tutti i dati personali trattati per conto del titolare del trattamento e certifica a quest'ultimo di averlo fatto, oppure restituisce al titolare del trattamento tutti i dati personali e cancella le copie esistenti, a meno che il diritto dell'Unione o dello Stato membro non richieda la conservazione dei dati personali. Finché i dati non sono cancellati o restituiti, il responsabile del trattamento continua ad assicurare il rispetto delle presenti clausole.",
          margin: [0,4,0,0],
          style: "bodyText"
        },
        {
          image: images.footerDocVallauri,
          width: "500",
          margin: [0,10,0,0]
        },
        {
          text: "SUB RESPONSABILI",
          alignment: "center",
          margin: [0,10,0,0],
          bold: true
        },
        {
          text: "Il responsabile del trattamento si impegna a rispettare le condizioni per ricorrere a un altro responsabile del trattamento (art. 28 par. 2 e par. 4 Regolamento UE 2016/679).",
          margin: [0,5,0,0],
          style: "bodyText"
        },
        {
          text: "Il responsabile del trattamento non ricorrerà a un altro responsabile senza previa autorizzazione scritta specifica del Titolare del trattamento. Il sub-responsabile sarà chiamato a sottoscrivere, nei confronti del responsabile del trattamento, un accordo che rispetti le misure tecniche e organizzative poste dal presente accordo.",
          margin: [0,5,0,0],
          style: "bodyText"
        },
        {
          text: "REGISTRI DELLE ATTIVITÀ DI TRATTAMENTO",
          alignment: "center",
          margin: [0,10,0,0],
          bold: true
        },
        {
          text: "Per i trattamenti descritti nell'allegato II, il responsabile del trattamento Azienda iscritta a Valtis si impegna a tenere e aggiornare i registri del trattamento di cui all’art. 30 Regolamento UE n. 679/2016 nella forma e con i contenuti indicati dalla disposizione citata.",
          margin: [0,5,0,0],
          style: "bodyText"
        },
        {
          text: "DURATA",
          alignment: "center",
          margin: [0,10,0,0],
          bold: true
        },
        {
          text: "Il presente accordo ha durata decennale salvo esplicita richiesta di cessazione e disiscrizione da ValtIS oppure espressa volontà nel prolungare il periodo di permanenza sulla piattaforma.",
          margin: [0,5,0,0],
          style: "bodyText"
        },
        {
          text: "Al momento della conclusione del presente accordo, il responsabile del trattamento si impegna, su scelta del titolare del trattamento, a cancellare o restituire tutti i dati personali dopo che è terminata la prestazione dei servizi relativi al trattamento e cancellare le copie esistenti, salvo che il diritto dell'Unione o degli Stati membri preveda la conservazione dei dati.",
          margin: [0,5,0,0],
          style: "bodyText"
        },


        {
          text: "Fossano, " + this.elements.dataDocumento,
          style: "bodyText",
          margin: [0, 20, 0, 0]
        },
        {
          text: "Firma del Titolare del Trattamento",
          style: "bodyText",
          alignment: "right",
          margin: [0, 10, 0, 0]
        },
        {
          text: this.elements.nomeIstituto,
          style: "bodyText",
          alignment: "right",
          bold: "true",
          margin: [0, 5, 0, 0]
        },
        {
          image: images.firmaVallauri,
          width: 200,
          alignment: "right",
          // pageBreak: "after"
        },
        // {
        //   image: this.elements.firmaUno,
        //   width: 200,
        //   alignment: "right",
        //   pageBreak: "after"
        // },
        {
          text:
            "Con la firma in calce a tale documento accetto la nomina a Responsabile del Trattamento per i trattamenti prima riportati insieme alle loro caratteristiche peculiari",
          style: "bodyText",
          margin: [0, 10, 0, 10]
        },
        {
          text: "Firma del Titolare del Trattamento",
          style: "bodyText",
          alignment: "right",
          margin: [0, 10, 0, 0]
        },
        {
          text: this.elements.nomeAzienda,
          style: "bodyText",
          alignment: "right",
          bold: "true",
          margin: [0, 5, 0, 0]
        },
        {
          image: this.elements.firmaUno,
          width: 200,
          alignment: "right",
          pageBreak: "after"
        },
        // {
        //   image: images.footerDocVallauri,
        //   width: "500",
        //   margin: [0,10,0,0]
        // },
        // {
        //   image: images.headerDocVallauri,
        //   width: "500",
        // },
        {
          text:
            "Ove applicabile, il presente documento annulla e sostituisce ogni altro documento di nomina a Responsabile del Trattamento di " + this.elements.nomeAzienda +", già esistente e sottoscritto",
          style: "bodyText",
          margin: [0, 25, 0, 0]
        },
        {
          text: "Firma del Titolare del Trattamento",
          style: "bodyText",
          alignment: "right",
          margin: [0, 10, 0, 0]
        },
        {
          text: this.elements.nomeIstituto,
          style: "bodyText",
          alignment: "right",
          bold: "true",
          margin: [0, 5, 0, 0]
        },
        {
          image: images.firmaVallauri,
          width: 200,
          alignment: "right"
        },
        {
          text: "Firma del Responsabile del Trattamento",
          style: "bodyText",
          alignment: "right",
          margin: [0, 30, 0, 0]
        },
        {
          text: this.elements.nomeAzienda,
          style: "bodyText",
          alignment: "right",
          bold: "true",
          margin: [0, 5, 0, 0]
        },
        {
          image: this.elements.firmaDue,
          width: 200,
          alignment: "right",
          pageBreak: "after"
        },
        {
          text: "ALLEGATO I",
          alignment: "center",
          margin: [0,0,0,0],
          bold: true
        },
        {
          text: "Elenco delle parti",
          alignment: "center",
          style: "bodyText",
          margin: [0,15,0,0],
          italics: true,
          bold: true
        },
        {
          text: "Titolare/i del trattamento: ",
          style: "bodyText",
          margin: [0,15,0,0],
          bold: true
        },
        {
          text: "Nome: Istituto Istruzione Superiore 'Giancarlo Vallauri'",
          style: "bodyText",
          margin: [0,10,0,0],
        },
        {
          text: "Responsabile/i del trattamento: ",
          style: "bodyText",
          margin: [0,15,0,0],
          bold: true
        },
        {
          text: "Nome: " + this.elements.nomeAzienda,
          style: "bodyText",
          margin: [0,10,0,0],
          pageBreak: "after"
        },
        {
          text: "ALLEGATO II",
          alignment: "center",
          margin: [0,0,0,0],
          bold: true
        },
        {
          text: "Descrizione del trattamento",
          alignment: "center",
          style: "bodyText",
          margin: [0,15,0,0],
          italics: true,
          bold: true
        },
        {
          table: {
            widths: [150, "*"],
            body: [
              [
                { text: "Trattamento", style: "tableTitle" },
                {
                  text:
                    "Gestione dei 'Percorsi per le competenze trasversali e l'orientamento' dei tirocini e post diploma",
                  style: "tableText"
                }
              ],
              [
                { text: "Durata", style: "tableTitle" },
                {
                  text:
                    "La conservazione dei dati è effettuata per il periodo necessario e prestabilito affinchè si raggiungano le finalità prospettate.",
                  style: "tableText"
                }
              ],
              [
                { text: "Natura", style: "tableTitle" },
                {
                  text:
                    "Nominativo, indirizzo o altri elementi di identificazione personale; Origini razziali; Convinzioni religiose; adesione ad organizzazioni a carattere religioso; Origini etniche; Carte sanitarie; Lavoro (occupazione attuale, precedente, curriculum, ecc.); Istruzione e cultura; Attività economiche, commerciali, finanziarie e assicurative",
                  style: "tableText"
                }
              ],
              [
                { text: "Finalità", style: "tableTitle" },
                {
                  text:
                    "Istruzione e cultura - Attività di formazione ed in favore del diritto allo studio",
                  style: "tableText"
                }
              ],
              [
                { text: "Tipo di dati personali", style: "tableTitle" },
                {
                  text:
                    "Dati comuni; Dati sensibili; Dati relativi alla salute",
                  style: "tableText"
                }
              ],
              [
                { text: "Categorie di interessati", style: "tableTitle" },
                {
                  text:
                    "Scolari o studenti; ex studenti; Docenti; Tutor; Imprenditori; Personale dipendente",
                  style: "tableText"
                }
              ]
            ]
          },
          margin: [0, 10, 0, 10],
          pageBreak: "after"
        },
        {
          text: "ALLEGATO III",
          alignment: "center",
          margin: [0,0,0,0],
          bold: true
        },
        {
          text: "Misure tecniche e organizzative, comprese misure tecniche e organizzative per garantire la sicurezza dei dati",
          alignment: "center",
          style: "bodyText",
          margin: [0,15,0,0],
          italics: true,
          bold: true
        },
        {
          text: "Azienda iscritta a Valtis si impegna ad adottare ogni misura tecnica ed organizzativa adeguate per soddisfare quanto previsto dal Regolamento UE n. 679/2016 e garantire la tutela dei diritti dell’interessato.",
          style: "bodyText",
          margin: [0,15,0,0]
        },
        {
          text: "- 	si impegna ad adottare le misure di sicurezza espressamente previste all’art. 32 Reg. UE n. 679/2016.",
          style: "bodyText",
          margin: [0,5,0,0]
        },
        {
          text: "- 	In  particolare, si impegna a osservare le disposizioni che vengono impartite dal Titolare, ad attuare gli obblighi di informativa e di acquisizione del consenso nei confronti degli interessati, nonché di assistere tempestivamente gli interessati che presentino richieste inerenti l’esercizio dei loro diritti informando tempestivamente il Titolare del trattamento di tali richieste.",
          style: "bodyText",
          margin: [0,5,0,0]
        },
        {
          text: "- 	predispone e aggiorna un sistema di sicurezza adeguato. ",
          style: "bodyText",
          margin: [0,5,0,0]
        },
        {
          text: "- 	si attiene solo ai trattamenti previsti dal presente contratto, salvo che in presenza di obblighi di legge.  ",
          style: "bodyText",
          margin: [0,5,0,0],
          pageBreak: "after"
        },
        {
          text: "ALLEGATO IV",
          alignment: "center",
          margin: [0,0,0,0],
          bold: true
        },
        {
          text: "Elenco dei sub-responsabili del trattamento",
          alignment: "center",
          style: "bodyText",
          margin: [0,15,0,0],
          italics: true,
          bold: true
        },
        {
          table: {
            widths: [150, "*"],
            body: [
              [
                { text: "Denominazione", style: "tableTitle" },
                {
                  text:"",
                  style: "tableText"
                }
              ],
              [
                { text: "Indirizzo", style: "tableTitle" },
                {
                  text:"",
                  style: "tableText"
                }
              ],
              [
                { text: "Dati contatto", style: "tableTitle" },
                {
                  text:"",
                  style: "tableText"
                }
              ],
              [
                { text: "Trattamenti", style: "tableTitle" },
                {
                  text:"",
                  style: "tableText"
                }
              ],
            ]
          },
          margin: [0, 10, 0, 10]
        },
      ],
      styles: {
        bodyText: {
          fontSize: 10,
          justified: true
        },
        tableTitle: {
          fontSize: 10,
          bold: "true",
          alignment: "right"
        },
        tableText: {
          fontSize: 8
        },
        bodyTextHighlight: {
          fontSize: 10,
          justified: true,
          background: "yellow"
        }
      }
    };
    const pdfDocGenerator = pdfMake.createPdf(dd);
    pdfDocGenerator.getDataUrl(function(dataUrl: any) {
      const targetElement = document.querySelector("#iframeContainer");
      const embed = document.createElement("embed");
      embed.src = dataUrl;
      embed.id = "pdfPreview";
      embed.width = "1000";
      embed.height = "700";
      if (targetElement !== null) {
        targetElement.appendChild(embed);
      }
    });
  }

  back() {
    this["$router"].push("/elencoAziende");
  }

  backToModules() {
    this["$router"].push("/moduli");
  }

  confirm() {
    user
      .dispatchConfirmResponsabileDatiDoc(this["$store"], this.idDoc)
      .then(() => {
        var payload = {
          docType: "nominaResponsabile",
          idDoc: this.idDoc
        };
        data
          .dispatchEmailFromIdDoc(this["$store"], payload)
          .then(response => {
            var input = {
              docType: "nominaResponsabile",
              email: response.EMail
            };
            user
              .dispatchConfirmDoc(this["$store"], input)
              .then(() => {
                bus.$emit(
                  "successfullOperation",
                  "Documento confermato con successo"
                );
                this["$router"].push("/elencoAziende");
              })
              .catch(error => {
                if (error.response.status === 401) {
                  bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                  this["$router"].push("/login");
                } else {
                  bus.$emit(
                    "errorOperation",
                    "Errore nella conferma del documento"
                  );
                }
              });
          })
          .catch(error => {
            if (error.response.status === 401) {
              bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
              this["$router"].push("/login");
            } else {
              bus.$emit(
                "errorOperation",
                "Errore nella conferma del documento"
              );
            }
          });
      })
      .catch(error => {
        if (error.response.status === 401) {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", "Errore nella conferma del documento");
        }
      });
  }
  refuse() {
    user
      .dispatchRefuseResponsabileDatiDoc(this["$store"], this.idDoc)
      .then(() => {
        var payload = {
          docType: "nominaResponsabile",
          idDoc: this.idDoc
        };
        data
          .dispatchEmailFromIdDoc(this["$store"], payload)
          .then(response => {
            var input = {
              docType: "nominaResponsabile",
              email: response.EMail
            };

            user
              .dispatchRefuseDoc(this["$store"], input)
              .then(() => {
                bus.$emit(
                  "successfullOperation",
                  "Documento rifiutato con successo"
                );
                this["$router"].push("/elencoAziende");
              })
              .catch(error => {
                if (error.response.status === 401) {
                  bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                  this["$router"].push("/login");
                } else {
                  bus.$emit(
                    "errorOperation",
                    "Errore nel rifiutare il documento"
                  );
                }
              });
          })
          .catch(error => {
            if (error.response.status === 401) {
              bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
              this["$router"].push("/login");
            } else {
              bus.$emit("errorOperation", "Errore nel rifiutare il documento");
            }
          });
      })
      .catch(error => {
        if (error.response.status === 401) {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", "Errore nel rifiutare il documento");
        }
      });
  }

  created() {
    const payload = {
      idDoc: this.idDoc
    };
    data.dispatchDocNominaRespInfo(this["$store"], payload).then(() => {
      this.elements = data.readDocNominaRespInfo(this["$store"]);
      this.createDoc();
    });
  }
}
